import { useEffect, useState } from "react";
import IconSave from "../../components/icons/IconSave";
import { saveQuestionText } from "./api";

export default function QuestionText({ item, onSaved }) {
    const [textValue, setTextValue] = useState(item.text);
    const [isDirty, setIsDirty] = useState(false);

    // Keeps the textarea in sync when the question's text is updated
    // elsewhere (e.g. after a refetch), without needing to remount the node.
    useEffect(() => {
        setTextValue(item.text);
        setIsDirty(false);
    }, [item.text]);

    const handleChange = (e) => {
        setTextValue(e.target.value);
        setIsDirty(e.target.value != item.text);
    };

    const handleSave = (e) => {
        e.preventDefault();
        e.stopPropagation();

        saveQuestionText(item.id, textValue)
            .then(() => onSaved())
            .catch((err) => console.error(err));
    };

    return (
        <div className="question-plate-body">
            <div className="question-plate-text">
                <textarea name="text" placeholder="Напиши тут питання..." onChange={handleChange} value={textValue} />
                {isDirty ? (
                    <div className="save-changed-text-btn" onClick={handleSave}>
                        <IconSave fillColor="icon-green" style={{ height: 40, width: 40 }} />
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
}
